module.exports = __webpack_public_path__ + "img/logo_new2.d06efa4a.png";